module.exports = __webpack_public_path__ + "img/menu-alt.2b770701.svg";